/* global localStorage */
import * as MutationTypes from 'store/mutation-types'

// init state
const state = {
  formDataCache: {},
  waterfallChildDataCache: null,
  editedComponentName: {}
}

const getters = {
  waterfallChildDataCache() {
    return state.waterfallChildDataCache
  },
  formDataCache() {
    return state.formDataCache
  },
  editedComponentName() {
    return state.editedComponentName
  }
}

const mutations = {
  UPDATE_WATERFALL_CHILD_DATA_CACHE(state, data) {
    state.waterfallChildDataCache = data
  },
  UPDATE_FORM_DATA_CACHE(state, data) {
    state.formDataCache = data
  },
  UPDATE_EDITED_COMPONENT_NAME(state, data) {
    state.editedComponentName = data
  }
}

const actions = {
  async updateFormDataCache({ commit }, data) {
    await commit(MutationTypes.UPDATE_FORM_DATA_CACHE, data)
  },
  async updateWaterfallChildDataCache({ commit }, data) {
    await commit(MutationTypes.UPDATE_WATERFALL_CHILD_DATA_CACHE, data)
  },
  async updateEditedComponentName({ commit }, data) {
    await commit(MutationTypes.UPDATE_EDITED_COMPONENT_NAME, data)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
